// Copyright (c) 2016 Deere & Company

import {onSearch, updateQuery} from './search-box';
import {updateListFilterBy, updateListSortBy, updateListSortDirection} from './refine-list';
import {goToStatusChangeRequestView} from './status-change-request-view';
import {highOnRentalDays} from './high-rental-days';
import {routerActions} from 'react-router-redux';
import {updateSearchDropDown} from './search-dropdown';
import {updateSearchQueryString} from './search-query-string';

export default {
    ...routerActions,
    goToStatusChangeRequestView,
    highOnRentalDays,
    onSearch,
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection,
    updateQuery,
    updateSearchDropDown,
    updateSearchQueryString
};



// WEBPACK FOOTER //
// ./src/product/shared/action-creators/index.js